import { render, staticRenderFns } from "./inventory-query.vue?vue&type=template&id=66a0f69d&scoped=true&"
import script from "./inventory-query.vue?vue&type=script&lang=ts&"
export * from "./inventory-query.vue?vue&type=script&lang=ts&"
import style0 from "./inventory-query.vue?vue&type=style&index=0&id=66a0f69d&prod&lang=scss&scoped=true&"
import style1 from "./inventory-query.vue?vue&type=style&index=1&id=66a0f69d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0f69d",
  null
  
)

export default component.exports